

































































import { LoDashStatic } from 'lodash';
import Vue from 'vue';
import { Component, Inject, Prop } from 'vue-property-decorator';
import { AnswerUpdater } from './AnswerUpdater';
import { Answer } from './dataContracts';
import { DeclinedUpdater } from './DeclinedUpdater';
import { NoteUpdater } from './NoteUpdater';
import { ViewQuestion } from './ViewQuestion';

@Component
export default class SurveyQuestion extends Vue {
  private static readonly debounceWait = 500;

  @Prop(Object) private readonly question!: ViewQuestion;
  @Prop(Function) private readonly updateAnswer!: AnswerUpdater;
  @Prop(Function) private readonly updateDeclined!: DeclinedUpdater;
  @Prop(Function) private readonly updateNote!: NoteUpdater;

  @Inject('debounce')
  private readonly debounce!: LoDashStatic['debounce'];

  private debounceUpdate = this.debounce(
    this.updateAnswer,
    SurveyQuestion.debounceWait,
  );
  private debounceNoteUpdate = this.debounce(
    this.updateNote,
    SurveyQuestion.debounceWait,
  );

  private createNotesLabel(questionLabel: string) {
    return `Notes For ${questionLabel}`;
  }

  private answerToString(answer: Answer) {
    if (typeof answer === 'boolean' || answer === null) {
      return this.binaryToString(answer);
    }
    return answer;
  }

  private binaryToString(binary: boolean | null) {
    if (binary === true) {
      return 'true';
    } else if (binary === false) {
      return 'false';
    } else {
      return 'null';
    }
  }

  private stringToBinary(aString: string) {
    if (aString === 'true') {
      return true;
    } else if (aString === 'false') {
      return false;
    } else {
      return null;
    }
  }
}
